import {inject} from '@angular/core';
import {HttpInterceptorFn} from '@angular/common/http';
import {finalize} from 'rxjs/operators';
import {LoadingService} from '../../shared/services/loading.service';

const SILENT_URLS = [
  '/account/refresh-token',
];

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const isSilent = SILENT_URLS.some(url => req.url.includes(url));

  if (!isSilent) {
    loadingService.startLoading();
  }

  return next(req).pipe(
    finalize(() => {
      if (!isSilent) {
        loadingService.stopLoading();
      }
    })
  );
};
